(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["uykumo-photo-strip"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('uykumo-photo-gallery')) {
  customElements.define('uykumo-photo-gallery', class extends HTMLElement {
    connectedCallback() {
      if(this.ready) return;
      this.ready=true;
      const track=this.querySelector('.uykumo-photos__track');
      const prev=this.querySelector('[data-direction="-1"]');
      const next=this.querySelector('[data-direction="1"]');
      const update=()=>{prev.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-2;};
      this.querySelectorAll('[data-direction]').forEach(button=>button.addEventListener('click',()=>{
        const frame=track.querySelector('.uykumo-photos__frame');
        if(!frame) return;
        track.scrollBy({left:Number(button.dataset.direction)*(frame.getBoundingClientRect().width+4),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }));
      track.addEventListener('scroll',update,{passive:true});
      this.observer=new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback(){this.observer?.disconnect();this.ready=false;}
  });
}

  } catch(e) { console.error(e); }
})();
})();
